import { cx } from "@suse-o11y/class-variance";
import React from "react";

import styles from "./_dropdown-menu.module.css";

export type DropdownMenuHotkeyProps = React.ComponentProps<"code">;

export const DropdownMenuHotkey = React.forwardRef<React.ComponentRef<"code">, DropdownMenuHotkeyProps>(
	({ className, ...props }, ref) => <code className={cx(styles.hotkey, className)} ref={ref} {...props} />,
);

if (import.meta.env.DEV) {
	DropdownMenuHotkey.displayName = "DropdownMenuHotkey";
}
